/**
 * @generated SignedSource<<6576c2e97e1abc2697f657c77bed990e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyTalkingPointInput = {
  clientMutationId?: string | null;
  talkingPointId: string;
};
export type destroyTalkingPointMutation$variables = {
  input: DestroyTalkingPointInput;
};
export type destroyTalkingPointMutationVariables = destroyTalkingPointMutation$variables;
export type destroyTalkingPointMutation$data = {
  readonly destroyTalkingPoint: {
    readonly destroyedTalkingPointId: string | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type destroyTalkingPointMutationResponse = destroyTalkingPointMutation$data;
export type destroyTalkingPointMutation = {
  variables: destroyTalkingPointMutationVariables;
  response: destroyTalkingPointMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyTalkingPointPayload",
    "kind": "LinkedField",
    "name": "destroyTalkingPoint",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "destroyedTalkingPointId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "destroyTalkingPointMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "destroyTalkingPointMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "82bbf66e2a1151ed084f8637c7988ff8",
    "id": null,
    "metadata": {},
    "name": "destroyTalkingPointMutation",
    "operationKind": "mutation",
    "text": "mutation destroyTalkingPointMutation(\n  $input: DestroyTalkingPointInput!\n) {\n  destroyTalkingPoint(input: $input) {\n    destroyedTalkingPointId\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dca9a08b54cef57a6653f412bcd8a19";

export default node;
